import { useQuery } from '@tanstack/react-query';
import { getEthHourlyRule } from '../lib/apiClient';

// Settles at most once an hour; no need to poll faster.
const STALE_TIME_MS = 5 * 60_000;

/** Forward paper test of the ETH hourly rule. Hypothetical only. */
export function useEthHourlyRule() {
  return useQuery({
    queryKey: ['eth-hourly-rule'],
    queryFn: getEthHourlyRule,
    staleTime: STALE_TIME_MS,
    refetchInterval: STALE_TIME_MS,
  });
}
